exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-changeTime[data-v-2142973a]{margin:auto;width:4.16667rem}.flexRow[data-v-2142973a]{margin-bottom:0}.txtRow[data-v-2142973a]{margin-bottom:0}\n", ""]);

// exports
